import { render, staticRenderFns } from "./RegisterFileUpload.vue?vue&type=template&id=7ed32910"
import script from "./RegisterFileUpload.vue?vue&type=script&lang=js"
export * from "./RegisterFileUpload.vue?vue&type=script&lang=js"
import style0 from "./RegisterFileUpload.vue?vue&type=style&index=0&id=7ed32910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports